<div *ngIf="currentContact" id="contact-detail-container" [ngClass]="{'container' : contactType != 'createInModal'}">
    <h1 *ngIf="contactType == 'update'"><i class="fa fa-address-card-o fa-pre" aria-hidden="true"></i> Détail du
        contact</h1>
    <h1 *ngIf="contactType == 'create'"><i class="fa fa-address-card-o fa-pre" aria-hidden="true"></i> Création de
        contact</h1>
    <h2 *ngIf="contactType == 'createInModal'" style="margin-left: 30px">
        <i class="fa fa-address-card-o fa-pre" aria-hidden="true"></i> Création de contact
    </h2>

    <div *ngIf="currentContact.deleted === true">
        <h5>Contact supprimé</h5>
    </div>
    <div id="currentContacts-details-container" class="currentContact" *ngIf="currentContact.deleted === false">
        <form (submit)="saveContact()" name="contactForm" role="form" #updateContactForm="ngForm">
            <div style="margin: 0 35px;">
                <div class="row">
                    <div class="form-contact-details"
                        [ngClass]="{'col-md-12' : contactType === 'createInModal', 'col-md-6' : contactType !== 'createInModal' }">
                        <div class="row">
                            <h3 class="col-md-12">Requis</h3>
                        </div>
                        <div class="row">
                            <div class="col-md-3">
                                <label for="firstName" class="required">Prénom</label>
                            </div>
                            <div class="col-md-2">
                                <select class="form-control" id="title" required [(ngModel)]="currentContact.title"
                                    name="title" #name="ngModel">
                                    <option value="MRS">M</option>
                                    <option value="MS">Mme</option>
                                </select>
                            </div>
                            <div class="col-md-7">
                                <input type="text" class="form-control" id="firstName" required
                                    [(ngModel)]="currentContact.firstName" name="firstName" #name="ngModel">
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-3">
                                <label for="lastName" class="required">Nom</label>
                            </div>
                            <div class="col-md-9">
                                <input type="text" class="form-control" id="lastName" required
                                    [(ngModel)]="currentContact.lastName" name="lastName" #name="ngModel">
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-3">
                                <label for="lastName" class="required">Email</label>
                            </div>
                            <div class="col-md-9">
                                <input type="text" class="form-control" id="email" [(ngModel)]="currentContact.email"
                                    name="email" required #name="ngModel">
                            </div>
                        </div>
                        <div class="row" *ngIf="contactType==='createInModal'" [hidden]="true">
                            <div class="col-md-3">
                                <label for="companyModal" class="required">Entreprise</label>
                            </div>
                            <div class="col-md-8">
                                <input id="companyModal" [(ngModel)]="company.name" name="company" class="form-control"
                                    required disabled>
                            </div>
                        </div>

                        <div class="row" *ngIf="contactType!=='createInModal'">
                            <div class="col-md-3">
                                <label for="company" class="required">Entreprise</label>
                            </div>
                            <div class="col-md-8">
                                <input auto-complete [(ngModel)]="currentContact.company[0]"
                                    [source]="searchCompanies.bind(this)" [list-formatter]="myListFormatter"
                                    [accept-user-input]="false" [min-chars]="1" display-property-name="name"
                                    id="company" class="form-control" name="company"
                                    (valueChanged)="changeCompany($event)" (focus)="focusOnCompanyAutocomplete()"
                                    required autocomplete="off">
                            </div>
                            <div class="col-md-1 input-ok">
                                <span class="check" *ngIf="companySelected">
                                    <i class="fa fa-check" aria-hidden="true"></i>
                                </span>
                                <span class="times" *ngIf="!companySelected">
                                    <i class="fa fa-times" aria-hidden="true"></i>
                                </span>
                            </div>
                        </div>

                        <div class="row">
                            <h3 class="col-md-12">{{'global.form.optional'| translate}}</h3>
                        </div>
                        <div class="row">
                            <div class="col-md-3">
                                <label for="type" class="required">Type</label>
                            </div>
                            <div class="col-md-9">
                                <select class="form-control" id="type" [(ngModel)]="currentContact.type" name="type"
                                    required>
                                    <option [value]="'CONTACT'"
                                        [selected]="currentContact.type == 'CONTACT' ? 'selected' : ''">Contact
                                    </option>
                                    <option [value]="'INVOICE'"
                                        [selected]="currentContact.type == 'INVOICE' ? 'selected' : ''">Facturation
                                    </option>
                                </select>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-3">
                                <label for="phone">Téléphone</label>
                            </div>
                            <div class="col-md-9">
                                <input type="text" class="form-control" id="phone" [(ngModel)]="currentContact.phone"
                                    name="phone" #name="ngModel">
                            </div>
                        </div>
                        <div class="separator">
                            &nbsp;
                        </div>
                        <div class="row">
                            <div class="col-md-3">
                                <label for="job">Poste</label>
                            </div>
                            <div class="col-md-9">
                                <input type="text" class="form-control" id="job" [(ngModel)]="currentContact.job"
                                    name="job" #name="ngModel">
                            </div>
                        </div>
                        <div class="row">
                            <h3 class="col-md-12">Modalités d'emailing automatique</h3>
                        </div>
                        <div class="row">
                            <div class="col-md-12">
                                <label class="center-block radio-input-inline">
                                    <input
                                        type="radio"
                                        value="CONTACT_AND_STUDENTS"
                                        name="radio"
                                        [(ngModel)]="currentContact.emailingMode"
                                        required
                                    >
                                    Email au contact et aux stagiaires
                                </label>
                                <label class="center-block radio-input-inline">
                                    <input
                                        type="radio"
                                        value="CONTACT_ONLY"
                                        name="radio"
                                        [(ngModel)]="currentContact.emailingMode"
                                        required
                                    >
                                    Email au contact uniquement
                                </label>
                                <label class="center-block radio-input-inline">
                                    <input
                                        type="radio"
                                        value="STUDENTS_ONLY"
                                        name="radio"
                                        [(ngModel)]="currentContact.emailingMode"
                                        required
                                    >
                                    Email aux stagiaires uniquement
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <br>
            <div style="margin:10px 30px 30px;">
                <button class="btn btn-primary" [disabled]="!updateContactForm.valid" type="submit" name="submit">
                    Sauvegarder
                </button>
                <button *ngIf="contactType === 'update'" class="btn btn-default" type="button"
                    (click)="showModal(deleteModal)">
                    Supprimer
                </button>
            </div>
        </form>
    </div>
</div>


<ng-template #deleteModal>
    <div class="modal-header">
        <h4 class="modal-title">Etes-vous sur de vouloir supprimer ce contact ?</h4>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-default" (click)="closeModal()">Annuler</button>
        <button type="button" class="btn btn-primary" (click)="removeContact()">Supprimer</button>
    </div>
</ng-template>



// WEBPACK FOOTER //
// ./src/app/_screens/directory/contact/detail/detail.component.html